<template>
	<div class="app--engagement-documents app--engagement-groups page-content">
		<div class="app--engagement-group bg--group border--group">
			<div class="group-heading">
				<span class="title" :class="theme('title')">{{ trans('pdfs.title') }}</span>
				<span class="description" :class="theme('description')">{{ trans('pdfs.description') }}</span>
			</div>
			<div v-for="d in documents" class="group-content multiple engagement-document">
				<div class="group-row" :class="theme('rows')">
					<div class="title">{{ d.title }}</div>
					<div class="btn-group">
						<a :href="download(d)" target="_blank" class="primary text-uppercase app--button border--button"
							:title="trans('pdfs.open')">
							{{ trans('pdfs.open') }}
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import store from '../../store'

export default {
	computed: {
		documents() {
			return store.state.pdfs
		},
		preview() {
			return store.state.preview === true
		}
	},
	methods: {
		trans(value) { let trans = store.getters.trans(value); return trans ? trans : this.$t('front.' + value) },
		theme(key) {
			return [
				'text--color-' + store.state.theme.groups[key].color,
				'text--font-' + store.state.theme.groups[key].font,
				'text--size-' + store.state.theme.groups[key].size,
			]
		},
		download(d) {
			let path = '/e/media/pdf/'
			return path + store.state.id + '/' + d.id
		},
	},
	components: {}
}
</script>
